define('appkit/model/page.state',[
  'datakit/model',
  'underscore',
  'backbone'
], function(Model, _, Backbone) {

  var PageState = Model.extend({

  	initialize: function() {
  		Model.prototype.initialize.apply(this, arguments);

      this._fetchCount = 0;
  		this._responseCount = 0;
  		this._hasError = false;
  		this._xhrPool = [];
      this._pageResources = [];

      this.on('error', this.onError, this);
  	},

    changeRouteName: function(name) {
      // allows you to change the route name that a state change
      // will update
      // this event is caught by the application
      // and updates the scoped routeName
      // see app.js
      this.trigger('routeName', name);
      return this;
    },

    addPageResources: function(modelOrCollections, options) {
      if (!_.isArray(modelOrCollections)) {
  			modelOrCollections = [modelOrCollections];
  		}

      options = options || {};

  		_.each(modelOrCollections, function(model) {
        this._pageResources.push(model);
  			this.listenTo(model, 'request', this._onPageResourceRequest);
        if ((model instanceof Backbone.Model && model.isNew()) || options.noFetch === true) { return; }
        this._fetchCount++;
  			this.listenTo(model, 'sync', this._onPageResourceResponse);
  			this.listenTo(model, 'error', this._onPageResourceResponse);
  			this.listenTo(model, 'remove:resource', this._onPageResourceResponse);
  		}, this);

      // after the initialization tick, if no resources needed to request
  		// simply call completed.
  		var self = this;
      if (!this._deferCheck) {
        this._deferCheck = true;
    		_.defer(function() {
          self.checkSyncComplete();
    		});
      }

      return this;
    },

    removePageResources: function(modelOrCollections) {
      if (!_.isArray(modelOrCollections)) {
  			modelOrCollections = [modelOrCollections];
  		}

  		_.each(modelOrCollections, function(model) {
        // see if we can remove this
        // model as a dependency
        var index = _.indexOf(this._pageResources, model);
        if (index >= 0) {
          this._pageResources.splice(index, 1);
        }
        model.trigger('remove:resource');
        this.stopListening(model);
      }, this);

      this.checkSyncComplete();
      return this;
    },

  	// all models and collections need to be added in the same tick as the controller initializtion
  	addPageDependencies: function(modelOrCollections, options) {
  		if (!_.isArray(modelOrCollections)) {
  			modelOrCollections = [modelOrCollections];
  		}

  		_.each(modelOrCollections, function(model) {
  			if (model instanceof Backbone.Model && model.isNew()) { return; }
        this.listenTo(model, "error", this._onPageDependencyError);
  		}, this);

      return this.addPageResources(modelOrCollections, options);
  	},

    _onPageResourceResponse: function(model) {
      this._responseCount++;

      // after any successful response on a resource
      // we need to remove listeners to future response
      // so we don't over increase the syncCount
      this.stopListening(model, 'sync', this._onPageResourceResponse);
      this.stopListening(model, 'error', this._onPageResourceResponse);
      this.stopListening(model, 'remove:resource', this._onPageResourceResponse);
      this.stopListening(model, 'error', this._onPageDependencyError);

      // check to see if all resources have responded
      // in some way
      this.checkSyncComplete();
    },

    _onPageResourceRequest: function(model, jqXhr) {
      var done = function() {
				// remove the xhr from the pool.  We're done with it.
				this._xhrPool.splice(_.indexOf(this._xhrPool, jqXhr), 1);
        this.stopListening(model, 'sync', done);
        this.stopListening(model, 'error', done);
      };
			this.listenTo(model, 'sync error', done);
			this._xhrPool.push(jqXhr);
		},

    _onPageDependencyError: function(model) {
  		this.stopListening(model);
      this.trigger('error');
  	},

    onError: function(e) {
      if (!this._hasError) {
  		  this._hasError = true;
  		  this.trigger('page:error', e);
  		}
    },

    checkSyncComplete: function() {
      if (this.isDone()) {
  			this._allSyncsDidComplete();
  		}
    },

  	// page successfully loaded
  	_allSyncsDidComplete: function() {
  	   this.trigger('page:loaded');
		},

		_abortPendingPageResources: function() {
			_.each(this._xhrPool, function(jqXhr) {
				jqXhr.abort();
			});
		},

  	stop: function() {
  		if (!this.isDone()) {
	  		this._abortPendingPageResources();
  		  this.trigger('page:cancel');
  		}
      this._xhrPool = [];
      this.trigger('page:exit');
      // lets clean this stuff up
      _.each(this._pageResources, function(resource) {
        resource.stopListening().off();
      });
		  this.stopListening().off();
      return this;
  	},

  	isDone: function() {
  	  return this._responseCount === this._fetchCount && !this._hasError;
  	}

  });

  return PageState;
});

